(() => {
  const selector = [
    '#MainContent h1','#MainContent h2','#MainContent h3',
    'main h1','main h2','main h3',
    '.shopify-policy__container h1','.shopify-policy__container h2','.shopify-policy__container h3'
  ].join(',');

  function lastTextNode(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node = null;
    let current;
    while ((current = walker.nextNode())) {
      if (current.nodeValue && current.nodeValue.trim()) node = current;
    }
    return node;
  }

  function previousTextNode(node) {
    let current = node.previousSibling;
    while (current) {
      if (current.nodeType === Node.TEXT_NODE && current.nodeValue.trim()) return current;
      if (current.nodeType === Node.ELEMENT_NODE) {
        const found = lastTextNode(current);
        if (found) return found;
      }
      current = current.previousSibling;
    }
    return null;
  }

  function cleanHeading(heading) {
    if (!(heading instanceof HTMLElement)) return;

    heading.querySelectorAll('br').forEach((br) => {
      const node = previousTextNode(br);
      if (node) node.nodeValue = node.nodeValue.replace(/\.\s*$/, '');
    });

    const tail = lastTextNode(heading);
    if (tail) tail.nodeValue = tail.nodeValue.replace(/\.\s*$/, '');

    const normalized = heading.textContent.replace(/\s+/g, ' ').trim().toLocaleUpperCase('de-DE');
    if (normalized === 'KURZ GEKLÄRT' || normalized === 'KURZ GEKLÄRT.') {
      heading.textContent = 'KURZ ERKLÄRT';
    }

    const walker = document.createTreeWalker(heading, NodeFilter.SHOW_TEXT);
    let textNode;
    while ((textNode = walker.nextNode())) {
      if (/dienselbe/i.test(textNode.nodeValue)) {
        textNode.nodeValue = textNode.nodeValue.replace(/dienselbe/gi, 'dieselbe');
      }
    }
  }

  function run(root = document) {
    if (root.matches && root.matches(selector)) cleanHeading(root);
    if (root.querySelectorAll) root.querySelectorAll(selector).forEach(cleanHeading);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => run(document), { once: true });
  } else {
    run(document);
  }

  document.addEventListener('shopify:section:load', (event) => run(event.target));

  const observer = new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType === Node.ELEMENT_NODE) run(node);
      }
    }
  });

  const startObserver = () => {
    const root = document.querySelector('#MainContent') || document.querySelector('main');
    if (root) observer.observe(root, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver, { once: true });
  } else {
    startObserver();
  }
})();
